module.exports = __webpack_public_path__ + "img/c2.7ef3277e.png";